import { render } from "./scenario-in-review.vue?vue&type=template&id=1676cfb4&ts=true"
import script from "./scenario-in-review.vue?vue&type=script&lang=ts"
export * from "./scenario-in-review.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__